import { NavItem, Product, Stat, Testimonial, BlogPost, Dealer } from './types';

export const NAV_ITEMS: NavItem[] = [
  { label: 'About Us', href: '#about' },
  { label: 'Products', href: '#products' },
  {
    label: 'Our Brands',
    href: '#brands',
    children: [
      {
        label: 'Wintuff',
        href: 'https://wintekprelams.com/images/catalogue.pdf',
        external: true,
        icon: '/assets/logos/dropdownicon.webp',
      },
      {
        label: 'Ample',
        href: '/assets/pdfs/cromaply-edit-no-last-page.pdf',
        external: true,
        icon: '/assets/logos/dropdown.webp',
      },
    ],
  },
  // { label: 'Blog', href: '#blog' },
  { label: 'Sale Center', href: '#distributor' },
];

export const HERO_STATS: Stat[] = [
  { value: '35+', label: 'Years of industry excellence' },
  { value: '700–900 kg/m³', label: 'High-density core strength' },
  { value: '72 Hours', label: 'Certified boiling-water proof durability' },
];

export const PRODUCTS: Product[] = [
  {
    id: 'protector',
    name: 'Croma Protector',
    subtitle: 'Fire Retardant BWP – IS 5509',
    description: "Croma Ply's special series of Fire Retardant Plywood provides strong protection against fire-related risks, helping reduce the impact of natural disasters on your structure. It is a precisely engineered plywood that ensures safety while maintaining aesthetic elegance.",
    specs: [
      { label: 'Grade:', value: 'BWP + Fire Retardant' },
      { label: 'Density:', value: '750–900 kg/m³' },
    ],
    tags: ['Fire Retardant Technology', 'ISI/BIS Certified Quality', 'High Strength & Durability', 'Termite & Borer Resistant', '100% Hardwood Core', 'Precision Manufacturing'],
    image: '/assets/images/products/Croma_Protector.webp',
    grade: 'BWP GRADE',
    certification: 'IS 5509',
    availableIn: { thickness: ['19mm', '16mm', '12mm', '9mm', '6mm'], size: ['8×4', '7×4', '6×4', '8×3', '7×3', '6×3'] },
    usp: ['Fire Retardant Technology', 'ISI/BIS Certified Quality', 'High Strength & Durability', 'Termite & Borer Resistant', '100% Hardwood Core', 'Long Life & Reliable Performance', 'Precision Manufacturing', 'Trusted Brand Assurance'],
    technicalSpecs: [
      { label: 'Grade', value: 'BWP, Fire Retardant' },
      { label: 'Standard', value: 'IS 5509' },
      { label: 'Species', value: 'Gurjan | Eucalyptus' },
      { label: 'Face Veneer', value: 'Gurjan' },
      { label: 'Size', value: '8×4, 7×4, 6×4, 8×3, 7×3, 6×3' },
      { label: 'Calibration', value: 'Both side calibrated (±0.3 mm)' },
      { label: 'Glue Used', value: 'PF' },
      { label: 'Thickness', value: '19mm, 16mm, 12mm, 9mm, 6mm' },
      { label: 'Density', value: '700–900 kg/m³' },
      { label: 'Moisture', value: '6–12%' },
      { label: 'Core Gap', value: 'Nil on top' },
      { label: 'Core Overlap', value: 'Nil on top' },
    ],
    features: [
      { icon: 'Flame', title: 'Fire Retardant Technology', desc: 'Strong protection against fire-related risks, helping reduce the impact of natural disasters on your structure.' },
      { icon: 'Award', title: 'ISI/BIS Certified Quality', desc: 'Manufactured to conform to ISI/BIS standards for certified quality and compliance.' },
      { icon: 'Shield', title: 'High Strength & Durability', desc: 'Precisely engineered plywood that delivers high strength and long-lasting durability.' },
      { icon: 'Bug', title: 'Termite & Borer Resistant', desc: 'Treated to protect against termite and borer infestation for reliable performance.' },
      { icon: 'Layers', title: '100% Hardwood Core', desc: 'Built with 100% hardwood core for consistent strength and stability.' },
      { icon: 'Shield', title: 'Long Life & Reliable Performance', desc: 'Engineered for long life and reliable performance in demanding applications.' },
      { icon: 'Ruler', title: 'Precision Manufacturing', desc: 'Precision manufacturing ensures safety while maintaining aesthetic elegance.' },
      { icon: 'Award', title: 'Trusted Brand Assurance', desc: 'Backed by Croma Ply\'s trusted brand assurance and quality commitment.' },
    ],
    applications: [
      { title: 'Interior & Exterior Woodwork', desc: 'All interior and exterior woodwork applications', img: 'https://images.unsplash.com/photo-1556911220-bff31c812dba?q=80&w=2400&auto=format&fit=crop' },
      { title: 'Silos, Sheathing & Structural Panels', desc: 'Silos, sheathing, plywood web beams, stress skin panels', img: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?q=80&w=2400&auto=format&fit=crop' },
      { title: 'Rail & Ship Containers', desc: 'Rail and ship containers, ships, bus and railway coaches', img: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?q=80&w=2400&auto=format&fit=crop' },
      { title: 'Cinema Halls, Restaurants & Exhibition Stalls', desc: 'Cinema halls, high rise buildings, restaurants, exhibition stalls, public places', img: 'https://images.unsplash.com/photo-1595515106969-1ce29566ff1c?q=80&w=2400&auto=format&fit=crop' },
      { title: 'Boiler Houses & Kitchens', desc: 'Boiler houses, kitchens, inner roof and wall linings', img: 'https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=2400&auto=format&fit=crop' },
      { title: 'Offices, Homes & Public Places', desc: 'Offices, homes, and all public places requiring fire-resistant protection', img: 'https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?q=80&w=2400&auto=format&fit=crop' },
    ],
  },
  {
    id: 'club-plus',
    name: 'Croma Club Plus',
    subtitle: 'BWP – IS 710',
    description: "Croma Ply's Structural Grade Plywood is engineered to deliver outstanding strength, stability, and long-lasting performance for demanding construction applications. Manufactured using high-density hardwood veneers and advanced bonding technology, this plywood is designed to withstand heavy loads with confidence. It is a preferred choice for builders, architects, and contractors seeking reliable construction plywood in India. Built for superior durability, Croma Club+ resists warping, bending, and moisture damage, ensuring consistent performance even under high stress. Whether used for flooring, roofing, or industrial frameworks, it performs dependably across a wide range of structural applications. The range is available in popular thicknesses such as 18 mm and 12 mm, including the versatile 12 mm 8×4 ft sheet suitable for projects of all sizes.",
    specs: [
      { label: 'Grade:', value: 'BWP (E1)' },
      { label: 'Density:', value: '850 kg/m³' },
    ],
    tags: ['Precision-engineered hardwood core', 'Japanese F★★★★ standards', 'Structural flooring', 'E0 Emission', 'Lifetime Guarantee with 700% Cashback'],
    image: '/assets/images/products/Croma_Club+.webp',
    grade: 'BWP GRADE',
    certification: 'IS 710',
    availableIn: { thickness: ['19mm', '16mm', '12mm', '9mm', '6mm'], size: ['8×4', '7×4', '6×4', '8×3', '7×3', '6×3'] },
    usp: ['Immune to Termites', 'Both Side Calibrated', 'High Density of 850 kg/m³', 'Low Flammability', 'Fire Resistance of 60 minutes', 'Immune to Borers', 'Double Surface Sanding for Superior Surface Finish', 'Lesser Tendency to Spark and Ignite', 'Lesser Smoke Generation', 'E0 Emission', 'Specially Formulated Fireproofing Chemicals Infusions', 'Pre Composed Core and Panels to Reduce Gaps', 'Slow Burning', 'Immune to Microbes', 'Super Premium Grade Product', 'Higher Flame Penetration Time', 'Decreased Chances of Fire to Spread over the Surface of the Plywood', 'Lifetime Guarantee with 700% Cashback'],
    technicalSpecs: [
      { label: 'Grade', value: 'BWP' },
      { label: 'Standard', value: 'IS 710 / Japanese F★★★★' },
      { label: 'Core', value: 'Mixed Gurjan & selected hardwood species' },
      { label: 'Face Veneer', value: 'Gurjan' },
      { label: 'Glue Used', value: 'BWP adhesive (E1) as per BIS 848' },
      { label: 'Size', value: '8×4, 7×4, 6×4, 8×3, 7×3, 6×3' },
      { label: 'Thickness', value: '19mm, 16mm, 12mm, 9mm, 6mm' },
      { label: 'Density', value: '850 kg/m³' },
      { label: 'Performance', value: 'India\'s first super-premium grade plywood. Resists warping, bending, and moisture. E0 emission. Fire resistance 60 minutes. Lifetime guarantee with 700% cashback.' },
    ],
    features: [
      { icon: 'Layers', title: 'Precision-Engineered Hardwood Core', desc: 'Precision-engineered hardwood core for uniform performance across all applications.' },
      { icon: 'Droplets', title: 'Resistance to Moisture, Bending & Warping', desc: 'Excellent resistance to moisture, bending, and warping for consistent performance under stress.' },
      { icon: 'Ruler', title: 'Structural Flooring', desc: 'Ideal for structural flooring applications in residential, commercial, and industrial construction.' },
      { icon: 'Award', title: 'Japanese F★★★★ Standards', desc: 'India\'s first super-premium grade plywood conforming to Japanese F★★★★ standards.' },
      { icon: 'Ruler', title: 'Smooth, Workable Surface', desc: 'Smooth, workable surface for easy finishing and superior surface quality.' },
      { icon: 'Building2', title: 'Residential, Commercial & Industrial', desc: 'Suitable for residential, commercial, and industrial construction applications.' },
    ],
    applications: [
      { title: 'Interior & Exterior Woodwork', desc: 'All types of interior and exterior woodwork, silos, sheathing, rail and ship containers', img: 'https://images.unsplash.com/photo-1556911220-bff31c812dba?q=80&w=2400&auto=format&fit=crop' },
      { title: 'Plywood Web Beams & Stress Skin Panels', desc: 'Plywood web beams, stress skin panels, and structural frameworks', img: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?q=80&w=2400&auto=format&fit=crop' },
      { title: 'Ships, Bus & Railway Coaches', desc: 'Ships, bus coaches, railway coaches, and transport applications', img: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?q=80&w=2400&auto=format&fit=crop' },
      { title: 'Cinema Halls, High-Rise & Restaurants', desc: 'Cinema halls, high-rise buildings, restaurants, exhibition stalls, public places', img: 'https://images.unsplash.com/photo-1595515106969-1ce29566ff1c?q=80&w=2400&auto=format&fit=crop' },
      { title: 'Boiler Houses, Kitchens & Linings', desc: 'Boiler houses, kitchens, inner roof and wall linings', img: 'https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=2400&auto=format&fit=crop' },
      { title: 'Offices, Homes & More', desc: 'Offices, homes, and all applications requiring superior structural plywood', img: 'https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?q=80&w=2400&auto=format&fit=crop' },
    ],
  },
  {
    id: 'gold-bwp',
    name: 'Croma Gold BWP',
    subtitle: 'Marine Grade',
    description: "Manufactured in one of India's most advanced facilities, equipped with state-of-the-art machinery from Europe and Taiwan, every panel of Marine Grade Plywood is produced using a mat-based process and enhanced with the Tetra-Cycle Advantage. Built with advanced technology, it is an ideal choice for anyone seeking a highly precise and reliable plywood solution.",
    specs: [
      { label: 'Grade:', value: 'Marine BWP Grade' },
      { label: 'Density:', value: '750–800 kg/m³' },
    ],
    tags: ['Tetra-Cycle Advantage', 'High load-bearing capacity', 'Engineered hardwood core', 'Both Side Calibrated', 'Lifetime Guarantee with 300% cashback'],
    image: '/assets/images/products/CromaPly_BWP.webp',
    grade: 'MARINE BWP GRADE',
    certification: 'IS 303',
    availableIn: { thickness: ['19mm', '16mm', '12mm', '9mm', '6mm'], size: ['8×4', '7×4', '6×4', '8×3', '7×3', '6×3'] },
    usp: ['Highly Durable', 'Made out of Hardwood Timber', 'Dimensional Stability', 'Both Side Calibrated', 'Immune to Termites', 'Immune to Microbes', 'Lifetime Guarantee with 300% cashback'],
    technicalSpecs: [
      { label: 'Grade', value: 'BWP Marine' },
      { label: 'Core', value: 'High-density hardwood species' },
      { label: 'Face Veneer', value: 'Okoume' },
      { label: 'Glue Used', value: 'Phenol Formaldehyde (BWP grade)' },
      { label: 'Size', value: '8×4, 7×4, 6×4, 8×3, 7×3, 6×3' },
      { label: 'Thickness', value: '19mm, 16mm, 12mm, 9mm, 6mm' },
      { label: 'Performance', value: 'Mat-based process with Tetra-Cycle Advantage. State-of-the-art machinery. High load-bearing capacity, moisture resistance, and dimensional stability.' },
    ],
    features: [
      { icon: 'Shield', title: 'High Load-Bearing Capacity', desc: 'High load-bearing capacity for strong structural performance.' },
      { icon: 'Layers', title: 'Engineered Hardwood Core', desc: 'Engineered hardwood core for uniform strength and stability.' },
      { icon: 'Droplets', title: 'Resistance to Moisture, Bending & Warping', desc: 'Excellent resistance to moisture, bending, and warping.' },
      { icon: 'Shield', title: 'Strong Bonding Technology', desc: 'Strong bonding technology for long-term durability.' },
      { icon: 'Ruler', title: 'Smooth, Calibrated Surface', desc: 'Smooth, calibrated surface for easy finishing and installation.' },
      { icon: 'Shield', title: 'Reliable Under Heavy Load', desc: 'Reliable performance under heavy and continuous load conditions.' },
      { icon: 'Building2', title: 'Residential, Commercial & Industrial', desc: 'Suitable for residential, commercial, and industrial applications.' },
      { icon: 'Ruler', title: 'Precision Manufacturing', desc: 'Precision manufacturing for consistent quality and performance.' },
    ],
    applications: [
      { title: 'Kitchens', desc: 'Moisture-resistant strength for kitchen cabinetry', img: 'https://images.unsplash.com/photo-1556911220-bff31c812dba?q=80&w=2400&auto=format&fit=crop' },
      { title: 'Bathrooms', desc: 'High-moisture environments requiring durability', img: 'https://images.unsplash.com/photo-1595515106969-1ce29566ff1c?q=80&w=2400&auto=format&fit=crop' },
      { title: 'Structural & Marine', desc: 'Marine grade applications, structural framing, and heavy-load use', img: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?q=80&w=2400&auto=format&fit=crop' },
      { title: 'Residential & Commercial', desc: 'Furniture, interiors, and construction for residential and commercial projects', img: 'https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=2400&auto=format&fit=crop' },
    ],
  },
  {
    id: 'gold-mr',
    name: 'Croma Gold MR',
    subtitle: 'Moisture Resistant',
    description: "Croma Ply's Excel Plywood delivers the advantage of affordability without compromising on quality. It helps protect furniture from excess moisture and is suitable for a wide range of both interior and exterior applications.",
    specs: [
      { label: 'Grade:', value: 'MR Grade Plywood' },
      { label: 'Density:', value: '>750 kg/m³' },
    ],
    tags: ['MR Grade', 'Moisture Resistant', 'Strong bonding', 'Cost-effective', 'Lifetime Guarantee with 300% Cashback'],
    image: '/assets/images/products/CromaPly_MR.webp',
    grade: 'MR GRADE',
    certification: 'IS 303',
    availableIn: { thickness: ['19mm', '16mm', '12mm', '9mm', '6mm'], size: ['8×4', '7×4', '6×4', '8×3', '7×3', '6×3'] },
    usp: ['Highly Durable', 'Resistant to Termites', 'Made out of Hardwood Timber', 'Resistant to Microbes', 'Dimensional Stability', '60 Degree Hot Water Resistant', 'Both Side Calibrated', 'Lifetime Guarantee with 300% Cashback'],
    technicalSpecs: [
      { label: 'Grade', value: 'MR' },
      { label: 'Core', value: 'High-density hardwood species' },
      { label: 'Face Veneer', value: 'Okoume' },
      { label: 'Glue Used', value: 'Special fortified MR resin' },
      { label: 'Size', value: '8×4, 7×4, 6×4, 8×3, 7×3, 6×3' },
      { label: 'Thickness', value: '19mm, 16mm, 12mm, 9mm, 6mm' },
      { label: 'Density', value: '>750 kg/m³' },
      { label: 'Performance', value: 'Moisture resistant for everyday interior use. Strong bonding, smooth surface, good screw and nail holding. Resistant to swelling and surface cracking.' },
    ],
    features: [
      { icon: 'Droplets', title: 'Moisture Resistant (MR Grade)', desc: 'MR Grade for everyday interior use, protecting furniture from excess moisture.' },
      { icon: 'Shield', title: 'Strong Bonding', desc: 'Strong bonding for enhanced durability and long life.' },
      { icon: 'Ruler', title: 'Smooth and Uniform Surface', desc: 'Smooth and uniform surface for better finishing.' },
      { icon: 'Hammer', title: 'Good Screw and Nail Holding', desc: 'Good screw and nail holding strength for secure installations.' },
      { icon: 'Shield', title: 'Resistant to Swelling & Cracking', desc: 'Resistant to swelling and surface cracking.' },
      { icon: 'Home', title: 'Ideal for Furniture & Cabinets', desc: 'Ideal for furniture, cabinets, and interior applications.' },
      { icon: 'Award', title: 'Reliable & Cost-Effective', desc: 'Reliable performance with cost-effective value.' },
      { icon: 'Ruler', title: 'Both Side Calibrated', desc: 'Both side calibrated for dimensional stability and consistent quality.' },
    ],
    applications: [
      { title: 'Furniture & Cabinets', desc: 'Ideal for furniture, cabinets, and interior applications', img: 'https://images.unsplash.com/photo-1556911220-bff31c812dba?q=80&w=2400&auto=format&fit=crop' },
      { title: 'Wardrobes & Storage', desc: 'Storage solutions, wardrobes, and built-in units', img: 'https://images.unsplash.com/photo-1595515106969-1ce29566ff1c?q=80&w=2400&auto=format&fit=crop' },
      { title: 'Interior & Exterior Woodwork', desc: 'Wide range of interior and exterior applications', img: 'https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=2400&auto=format&fit=crop' },
      { title: 'Residential & Office', desc: 'Cost-effective choice for residential and office spaces', img: 'https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?q=80&w=2400&auto=format&fit=crop' },
    ],
  },
  {
    id: 'engineered-bwp',
    name: 'Croma Engineered BWP',
    subtitle: '',
    description: 'Engineered marine plywood offering strength, stability, and superior surface finish.',
    specs: [
      { label: 'Grade:', value: 'BWP Grade' },
      { label: 'Density:', value: '700–900 kg/m³' },
    ],
    tags: ['IS 710 Compliant Construction', 'Engineered Layer Composition', 'Borer & Termite Resistance', 'Both-Side Calibration', 'High Surface Quality', 'Structural Stability'],
    image: '/assets/images/products/CromaPly_BWP.webp',
    grade: 'BWP GRADE',
    certification: 'IS 710',
    availableIn: { thickness: ['6mm', '9mm', '12mm', '16mm', '18mm', '19mm'], size: ['8×4'] },
    usp: ['IS 710 compliant', 'Engineered layer composition', 'Borer & termite resistance', 'Both-side calibration', 'High surface quality', 'Structural stability'],
    technicalSpecs: [
      { label: 'Standard', value: 'IS 710' },
      { label: 'Variants', value: 'All Red 710 – 100% hardwood, Alternate 710 – alternate layers of two hardwood species' },
      { label: 'Face Veneer', value: 'Recon' },
      { label: 'Size', value: '8×4' },
      { label: 'Thickness', value: '6mm, 9mm, 12mm, 16mm, 18mm, 19mm + special orders' },
      { label: 'Density', value: '700–900 kg/m³' },
    ],
    features: [
      { icon: 'Shield', title: 'IS 710 Compliant Construction', desc: 'Manufactured in accordance with IS 710 marine grade specifications.' },
      { icon: 'Layers', title: 'Engineered Layer Composition', desc: 'Available in All-Red hardwood and Alternate hardwood constructions.' },
      { icon: 'Bug', title: 'Borer & Termite Resistance', desc: 'Chemically treated to resist biological attacks.' },
      { icon: 'Ruler', title: 'Both-Side Calibration', desc: 'Precision calibration for dimensional accuracy.' },
      { icon: 'Award', title: 'High Surface Quality', desc: 'Designed to deliver a superior surface finish.' },
      { icon: 'Shield', title: 'Structural Stability', desc: 'Engineered for consistent strength and long-term performance.' },
    ],
    applications: [
      { title: 'Commercial Furniture', desc: 'Heavy-duty commercial furniture applications', img: 'https://images.unsplash.com/photo-1556911220-bff31c812dba?q=80&w=2400&auto=format&fit=crop' },
      { title: 'Heavy-duty Interior Projects', desc: 'Projects requiring superior strength and stability', img: 'https://images.unsplash.com/photo-1595515106969-1ce29566ff1c?q=80&w=2400&auto=format&fit=crop' },
    ],
  },
  {
    id: 'engineered-mr',
    name: 'Croma Engineered MR',
    subtitle: '',
    description: 'Moisture-resistant engineered plywood for stable interior applications.',
    specs: [
      { label: 'Grade:', value: 'MR Grade' },
      { label: 'Face:', value: 'Recon' },
    ],
    tags: ['Moisture-Resistant Grade Manufacturing', 'Engineered Hardwood Core', 'Warp-Resistant Structure', 'Both-Side Calibration', 'Mat Ply Construction', 'Interior-Focused Performance'],
    image: '/assets/images/products/CromaPly_MR.webp',
    grade: 'MR GRADE',
    certification: 'IS 303',
    availableIn: { thickness: ['6mm', '9mm', '12mm', '16mm', '18mm', '19mm'], size: ['8×4'] },
    usp: ['Moisture-resistant grade', 'Engineered hardwood core', 'Warp-resistant structure', 'Both-side calibration', 'Mat ply construction', 'Interior-focused performance'],
    technicalSpecs: [
      { label: 'Variants', value: 'All Red MR – 100% hardwood, Alternate MR – alternate layers of two hardwood species' },
      { label: 'Face Veneer', value: 'Recon' },
      { label: 'Size', value: '8×4' },
      { label: 'Thickness', value: '6mm, 9mm, 12mm, 16mm, 18mm, 19mm + special orders' },
    ],
    features: [
      { icon: 'Droplets', title: 'Moisture-Resistant Grade Manufacturing', desc: 'Designed specifically for interior moisture conditions.' },
      { icon: 'Layers', title: 'Engineered Hardwood Core', desc: 'Constructed using hardwood layers for balanced strength.' },
      { icon: 'Ruler', title: 'Warp-Resistant Structure', desc: 'Engineered to reduce deformation over time.' },
      { icon: 'Ruler', title: 'Both-Side Calibration', desc: 'Maintains uniform panel thickness.' },
      { icon: 'Layers', title: 'Mat Ply Construction', desc: 'Enhances durability and surface consistency.' },
      { icon: 'Home', title: 'Interior-Focused Performance', desc: 'Suitable for residential and office interior applications.' },
    ],
    applications: [
      { title: 'Interior Furniture', desc: 'Bedroom and living room furniture applications', img: 'https://images.unsplash.com/photo-1556911220-bff31c812dba?q=80&w=2400&auto=format&fit=crop' },
      { title: 'Decorative Paneling', desc: 'Decorative paneling for interior spaces', img: 'https://images.unsplash.com/photo-1595515106969-1ce29566ff1c?q=80&w=2400&auto=format&fit=crop' },
      { title: 'Residential & Office Use', desc: 'Versatile applications for residential and office spaces', img: 'https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=2400&auto=format&fit=crop' },
    ],
  },
  {
    id: 'block-board-mr-bwp',
    name: 'Croma Block Board',
    subtitle: 'MR/BWP',
    description: 'Blockboard is made using Marine Grade plywood veneer with an Okume face veneer. It is available in options of 100% pinewood or selected timber, both offering an excellent finish when combined with fibreglass or varnish for furniture.',
    specs: [
      { label: 'Grade:', value: 'MR / BWP' },
      { label: 'Face Veneer:', value: 'Okoume' },
    ],
    tags: ['MR Grade', '100% Pine or Selected Timber', 'Hexaforce Technology', 'E1 Certified', 'Lifetime Guarantee'],
    image: '/assets/images/products/Croma_Block_Board_MR&BWP.webp',
    grade: 'MR / BWP GRADE',
    certification: 'E1',
    availableIn: { thickness: ['19mm', '22mm', '25mm'], size: ['8×4', '7×4', '6×4', '8×3', '7×3', '6×3'] },
    usp: ['Minimum Gap Filling', 'Resistant to Microbes', '100% Pine Inside', 'E1 Certified', 'Both Side Calibrated', 'Powered by Hexaforce', 'Resistant to Termites', 'Lifetime Guarantee (no cashback)'],
    technicalSpecs: [
      { label: 'Grade', value: 'MR / BWP' },
      { label: 'Face Veneer', value: 'Okoume (Marine Grade plywood veneer)' },
      { label: 'Core Options', value: '100% pinewood or selected timber' },
      { label: 'Size', value: '8×4, 7×4, 6×4, 8×3, 7×3, 6×3' },
      { label: 'Thickness', value: '19mm, 22mm, 25mm' },
      { label: 'Technology', value: 'Powered by Hexaforce' },
      { label: 'Certification', value: 'E1 Certified' },
      { label: 'Performance', value: 'Excellent finish with fibreglass or varnish. Minimum gap filling, both side calibrated. Resistant to termites and microbes.' },
    ],
    features: [
      { icon: 'Droplets', title: 'Moisture Resistant (MR Grade)', desc: 'MR Grade for interior applications.' },
      { icon: 'Shield', title: 'Strong and Durable Bonding', desc: 'Strong and durable bonding for long service life.' },
      { icon: 'Ruler', title: 'Smooth and Uniform Surface', desc: 'Smooth and uniform surface for superior finishing.' },
      { icon: 'Hammer', title: 'Screw and Nail Holding', desc: 'Excellent screw and nail holding strength.' },
      { icon: 'Shield', title: 'Reduced Swelling & Cracking', desc: 'Reduced swelling and surface cracking.' },
      { icon: 'Home', title: 'Furniture, Wardrobes & Cabinets', desc: 'Ideal for furniture, wardrobes, cabinets, and paneling.' },
      { icon: 'Award', title: 'Consistent Quality', desc: 'Consistent quality with reliable performance.' },
      { icon: 'Award', title: 'Cost-Effective', desc: 'Cost-effective solution for everyday interior use.' },
    ],
    applications: [
      { title: 'Furniture & Cabinets', desc: 'Ideal for furniture, wardrobes, cabinets with fibreglass or varnish finish', img: 'https://images.unsplash.com/photo-1556911220-bff31c812dba?q=80&w=2400&auto=format&fit=crop' },
      { title: 'Wardrobes & Paneling', desc: 'Wardrobes, paneling, and interior woodwork', img: 'https://images.unsplash.com/photo-1595515106969-1ce29566ff1c?q=80&w=2400&auto=format&fit=crop' },
      { title: 'Interior Applications', desc: 'Everyday interior use with selected timber or 100% pine core', img: 'https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=2400&auto=format&fit=crop' },
      { title: 'Residential & Commercial', desc: 'Cost-effective choice for residential and commercial interiors', img: 'https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?q=80&w=2400&auto=format&fit=crop' },
    ],
  },
  {
    id: 'flush-door-bwp',
    name: 'Croma Flush Door',
    subtitle: 'BWP',
    description: "As the entry point to any room, a door is an essential element of every space. That's why our flush doors are engineered with excellent dimensional stability to deliver superior strength and dependable security. We are committed to upholding reliability, integrity, and quality by offering affordable flush door solutions that enhance your interior experience.",
    specs: [
      { label: 'Grade:', value: 'BWP' },
      { label: 'Guarantee:', value: '25 Years' },
    ],
    tags: ['BWP Grade', 'IS 2202 Certified', 'Australian Pine Frames', 'Melia Dubia Core', '25 Years Guarantee', 'Termite Resistant'],
    image: '/assets/images/products/Croma_Flush_Door_BWP.webp',
    grade: 'BWP GRADE',
    certification: 'IS 2202',
    availableIn: { thickness: ['30mm', '32mm', '38mm'], size: ['8×4', '7×4', '6×4', '8×3', '7×3', '6×3'] },
    usp: ['All side frames made from premium Australian Pine wood', 'Core filled with high-quality Melia Dubia for strength and stability', 'Boiling Water Proof (BWP) grade for superior moisture resistance', 'Manufactured using advanced Direct Pressing Technology', 'Zero Gap Composing for better durability and finish', 'IS 2202 Certified quality assurance', 'Termite resistant for long-term protection', '25 Years Guarantee'],
    technicalSpecs: [
      { label: 'Grade', value: 'BWP (Boiling Water Proof)' },
      { label: 'Frame', value: 'Premium Australian Pine wood' },
      { label: 'Core', value: 'High-quality Melia Dubia' },
      { label: 'Technology', value: 'Advanced Direct Pressing Technology' },
      { label: 'Composing', value: 'Zero Gap Composing' },
      { label: 'Certification', value: 'IS 2202 Certified' },
      { label: 'Size', value: '8×4, 7×4, 6×4, 8×3, 7×3, 6×3' },
      { label: 'Thickness', value: '30mm, 32mm, 38mm' },
      { label: 'Guarantee', value: '25 Years' },
      { label: 'Performance', value: 'Excellent dimensional stability, superior strength, dependable security. Resistant to warping, bending, and cracking. Termite resistant.' },
    ],
    features: [
      { icon: 'Ruler', title: 'High Dimensional Stability', desc: 'High dimensional stability for long-lasting performance.' },
      { icon: 'Shield', title: 'Strong and Durable Construction', desc: 'Strong and durable construction for enhanced security.' },
      { icon: 'Ruler', title: 'Smooth and Uniform Surface', desc: 'Smooth and uniform surface for easy finishing and polishing.' },
      { icon: 'Shield', title: 'Resistant to Warping & Cracking', desc: 'Resistant to warping, bending, and cracking.' },
      { icon: 'Hammer', title: 'Screw and Hardware Holding', desc: 'Excellent screw and hardware holding strength.' },
      { icon: 'Building2', title: 'Residential & Commercial', desc: 'Suitable for both residential and commercial interiors.' },
      { icon: 'Ruler', title: 'Precision Manufactured', desc: 'Precision manufactured for consistent quality.' },
      { icon: 'Award', title: 'Cost-Effective & Reliable', desc: 'Cost-effective and reliable door solution.' },
    ],
    applications: [
      { title: 'Residential Doors', desc: 'Entry and interior doors for homes', img: 'https://images.unsplash.com/photo-1556911220-bff31c812dba?q=80&w=2400&auto=format&fit=crop' },
      { title: 'Commercial Interiors', desc: 'Doors for offices, retail, and commercial spaces', img: 'https://images.unsplash.com/photo-1595515106969-1ce29566ff1c?q=80&w=2400&auto=format&fit=crop' },
      { title: 'Room Partitions', desc: 'Interior partitions and room doors', img: 'https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=2400&auto=format&fit=crop' },
      { title: 'Main & Entry Doors', desc: 'Main entry and internal doors with superior strength and security', img: 'https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?q=80&w=2400&auto=format&fit=crop' },
    ],
  },
  {
    id: 'film-faced-shuttering',
    name: 'Croma Film Faced Shuttering Plywood',
    subtitle: 'BWP – IS 4990',
    description: 'Croma Film Faced Shuttering Plywood is engineered for high-performance concrete formwork and demanding construction environments. Manufactured as per IS 4990 standards using premium hardwood veneers and BWP-grade phenolic bonding, it ensures superior strength, durability, and reusability. The smooth film-coated surface delivers an excellent concrete finish while reducing maintenance and replacement costs. Designed for heavy-duty applications, it is the reliable choice for modern infrastructure and large-scale projects.',
    specs: [
      { label: 'Thickness:', value: '12mm, 15mm, 18mm, 21mm' },
      { label: 'Standard Size:', value: '2440 × 1220 mm (8 ft × 4 ft)' },
      { label: 'Variants:', value: '23 kg, 30 kg, 34 kg, 50 kg' },
    ],
    tags: ['IS 4990', 'High Load-Bearing Strength', '100% Waterproof Bonding', '20–30 Reusability', 'Premium Hardwood Core', 'Beams, Slabs, Columns & Bridges'],
    image: '/assets/images/products/Croma_Film_Faced_Shuttering_Plywood.webp',
    grade: 'BWP GRADE',
    certification: 'IS 4990',
    availableIn: { thickness: ['12mm', '15mm', '18mm', '21mm'], size: ['2440 × 1220 mm (8×4)'], variants: ['23 kg', '30 kg', '34 kg', '50 kg'] },
    usp: ['Manufactured as per IS 4990 standards', 'Premium hardwood core for maximum durability', 'High reusability ensures lower cost per use', 'Produces smooth and uniform concrete surface finish', 'Engineered for demanding construction environments', 'Reliable performance in large infrastructure projects'],
    technicalSpecs: [
      { label: 'Grade', value: 'BWP (Boiling Waterproof) / IS 4990 Shuttering Quality' },
      { label: 'Core Material', value: '100% Hardwood Veneers' },
      { label: 'Adhesive', value: 'Phenol Formaldehyde (PF) Resin – BWP Grade' },
      { label: 'Density', value: '750 – 800 kg/m³' },
      { label: 'Surface Finish', value: 'Smooth resin-coated / film-faced for superior concrete finish' },
      { label: 'Modulus of Rupture (MOR)', value: 'Minimum 35 N/mm²' },
      { label: 'Modulus of Elasticity (MOE)', value: 'Minimum 7000 N/mm²' },
      { label: 'Reusability', value: '20–30 repetitions (with proper handling)' },
    ],
    features: [
      { icon: 'Layers', title: 'High Load-Bearing Strength', desc: 'High load-bearing strength for heavy RCC formwork.' },
      { icon: 'Droplets', title: '100% Waterproof Bonding', desc: '100% waterproof bonding for long service life.' },
      { icon: 'Ruler', title: 'Smooth Film-Coated Surface', desc: 'Smooth film-coated surface for superior concrete finish.' },
      { icon: 'Shield', title: 'Resistant to Swelling, Warping & Delamination', desc: 'Resistant to swelling, warping, and delamination.' },
      { icon: 'Award', title: 'Multiple Reusability', desc: 'Multiple reusability for cost-effective construction.' },
      { icon: 'Flame', title: 'Durable Phenolic Resin Bonding', desc: 'Durable phenolic resin bonding for harsh site conditions.' },
      { icon: 'Building2', title: 'Beams, Slabs, Columns & Bridges', desc: 'Suitable for beams, slabs, columns, bridges & heavy RCC work.' },
    ],
    applications: [
      { title: 'High-rise Buildings', desc: 'Heavy-duty formwork for high-rise construction', img: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?q=80&w=2400&auto=format&fit=crop' },
      { title: 'Bridges & Flyovers', desc: 'Demanding formwork for infrastructure projects', img: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?q=80&w=2400&auto=format&fit=crop' },
      { title: 'Industrial & Commercial Structures', desc: 'Large-scale RCC formwork applications', img: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?q=80&w=2400&auto=format&fit=crop' },
      { title: 'Dams & Highways', desc: 'Heavy RCC formwork for civil infrastructure', img: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?q=80&w=2400&auto=format&fit=crop' },
      { title: 'General RCC Formwork', desc: 'General RCC formwork for construction projects', img: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?q=80&w=2400&auto=format&fit=crop' },
      { title: 'Columns, Beams & Slab Casting', desc: 'Columns, beams & slab casting', img: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?q=80&w=2400&auto=format&fit=crop' },
    ],
  },
];

export const TESTIMONIALS: Testimonial[] = [
  {
    id: '1',
    quote: '"Best Plywood factory You can get a wide range of products in best quality. Especially Calibrated plywood and shuttering"',
    name: 'Shailendra parashar',
    role: '',
    avatar: '/assets/testimonial/2.webp',
    productType: '',
    projectUse: 'Calibrated plywood, shuttering, construction',
  },
  {
    id: '2',
    quote: '"Croma Ply stands apart for its superior quality and consistency. We have used it in multiple residential projects with excellent results. The finish, strength, and durability are always reliable."',
    name: 'Ambika Ply Board Industries',
    role: 'Jodhpur',
    avatar: '/assets/testimonial/3.webp',
    productType: '',
    projectUse: 'Residential projects, interior construction',
  },
  {
    id: '3',
    quote: '"As a dealer, customer satisfaction is critical for us. Croma Ply delivers dependable quality with zero complaints. It has helped us build long-term trust with our customers."',
    name: 'Rudra Decor',
    role: 'Jaipur',
    avatar: '/assets/testimonial/4.webp',
    productType: '',
    projectUse: 'Dealer distribution, retail sales',
  },
  {
    id: '5',
    quote: '"Croma Ply plywood offers excellent resistance to termites and moisture. Even after years of use, the panels remain stable and strong. It is a dependable product for premium interiors."',
    name: 'Jain plywood house',
    role: 'Jaipur',
    avatar: '/assets/testimonial/5.webp',
    productType: '',
    projectUse: 'Premium interiors, moisture-resistant applications',
  },
  {
    id: '6',
    quote: '"Consistency in specifications is what sets Croma Ply apart. Every sheet meets the promised standards without variation. This reliability makes project execution smooth and stress-free."',
    name: 'Timber Plus',
    role: 'Kota, RJ',
    avatar: '/assets/testimonial/6.webp',
    productType: '',
    projectUse: 'Commercial projects, precision construction',
  },
  {
    id: '7',
    quote: '"For everyday interior applications where moisture resistance is required, this material offers a good balance of durability and ease of use. It\'s a practical choice across multiple project types."',
    name: 'Aura plywood',
    role: 'Kota, RJ',
    avatar: '/assets/testimonial/7.webp',
    productType: 'Moisture Resistant Ply | MR',
    projectUse: 'Apartments, offices, commercial interiors',
  },
  {
    id: '8',
    quote: '"Croma Ply is our preferred choice for high-end furniture work. The strong bonding and smooth surface enhance the final finish. Our customers immediately notice the quality difference."',
    name: 'Naman plywood and interior',
    role: 'Udaipur',
    avatar: '/assets/testimonial/8.webp',
    productType: '',
    projectUse: 'High-end furniture, interior solutions',
  },
  {
    id: '10',
    quote: '"After facing quality issues with other brands, we shifted to Croma Ply. Since then, customer complaints have reduced drastically. It has become one of our most trusted plywood brands"',
    name: 'Aar Aas Enterprises',
    role: 'Jaipur',
    avatar: '/assets/testimonial/9.webp',
    productType: '',
    projectUse: 'Commercial and residential projects',
  },
  {
    id: '11',
    quote: '"Croma Ply delivers exactly what it promises. From core strength to bonding quality, everything is top-class. It is a brand professionals can confidently rely on."',
    name: 'Charu plywood & Furniture solutions',
    role: 'Jaipur',
    avatar: '/assets/testimonial/10.webp',
    productType: '',
    projectUse: 'Furniture manufacturing, interior solutions',
  },
  {
    id: '12',
    quote: '"Croma Ply stands for trust, durability, and long service life. Our long-term experience with the brand has been excellent. It is truly one of India’s most reliable plywood brands."',
    name: 'Mewar Timber and Plywood',
    role: 'Udaipur',
    avatar: '/assets/testimonial/11.webp',
    productType: '',
    projectUse: 'Timber and plywood distribution, commercial projects',
  },
];

export const DEALERS: Dealer[] = [
  // Uttar Pradesh - UP Central
  {
    id: 1,
    name: "Croma Ply Dealer - Lucknow",
    distance: "",
    address: "Lucknow, Uttar Pradesh",
    phone: "+91 7527070447",
    status: "Open",
    isOpen: true,
    rating: 4.5,
    reviews: 0,
    tags: ["UP Central"],
    active: true,
    details: {
      image: "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?q=80&w=2400&auto=format&fit=crop",
      email: "info@cromaply.com",
      website: "www.cromaply.com",
      hours: [
        { day: "Monday - Saturday", time: "9:00 AM - 6:00 PM" },
        { day: "Sunday", time: "Closed" },
      ],
      services: ["Retail Sales", "Delivery", "Product Advice"],
      specialties: ["Premium Plywood", "BWP Grade", "MR Grade"],
    },
  },
  // Uttar Pradesh - UP West
  {
    id: 2,
    name: "Croma Ply Dealer - Kasgunj",
    distance: "",
    address: "Kasgunj, Uttar Pradesh",
    phone: "+91 7527070447",
    status: "Open",
    isOpen: true,
    rating: 4.5,
    reviews: 0,
    tags: ["UP West"],
    active: true,
    details: {
      image: "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?q=80&w=2400&auto=format&fit=crop",
      email: "info@cromaply.com",
      website: "www.cromaply.com",
      hours: [
        { day: "Monday - Saturday", time: "9:00 AM - 6:00 PM" },
        { day: "Sunday", time: "Closed" },
      ],
      services: ["Retail Sales", "Delivery", "Product Advice"],
      specialties: ["Premium Plywood", "BWP Grade", "MR Grade"],
    },
  },
  {
    id: 3,
    name: "Croma Ply Dealer - Noida",
    distance: "",
    address: "Noida, Uttar Pradesh",
    phone: "+91 7527070447",
    status: "Open",
    isOpen: true,
    rating: 4.5,
    reviews: 0,
    tags: ["UP West"],
    active: true,
    details: {
      image: "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?q=80&w=2400&auto=format&fit=crop",
      email: "info@cromaply.com",
      website: "www.cromaply.com",
      hours: [
        { day: "Monday - Saturday", time: "9:00 AM - 6:00 PM" },
        { day: "Sunday", time: "Closed" },
      ],
      services: ["Retail Sales", "Delivery", "Product Advice"],
      specialties: ["Premium Plywood", "BWP Grade", "MR Grade"],
    },
  },
  {
    id: 4,
    name: "Croma Ply Dealer - Ghaziabad",
    distance: "",
    address: "Ghaziabad, Uttar Pradesh",
    phone: "+91 7527070447",
    status: "Open",
    isOpen: true,
    rating: 4.5,
    reviews: 0,
    tags: ["UP West"],
    active: true,
    details: {
      image: "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?q=80&w=2400&auto=format&fit=crop",
      email: "info@cromaply.com",
      website: "www.cromaply.com",
      hours: [
        { day: "Monday - Saturday", time: "9:00 AM - 6:00 PM" },
        { day: "Sunday", time: "Closed" },
      ],
      services: ["Retail Sales", "Delivery", "Product Advice"],
      specialties: ["Premium Plywood", "BWP Grade", "MR Grade"],
    },
  },
  {
    id: 5,
    name: "Croma Ply Dealer - Agra",
    distance: "",
    address: "Agra, Uttar Pradesh",
    phone: "+91 7527070447",
    status: "Open",
    isOpen: true,
    rating: 4.5,
    reviews: 0,
    tags: ["UP West"],
    active: true,
    details: {
      image: "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?q=80&w=2400&auto=format&fit=crop",
      email: "info@cromaply.com",
      website: "www.cromaply.com",
      hours: [
        { day: "Monday - Saturday", time: "9:00 AM - 6:00 PM" },
        { day: "Sunday", time: "Closed" },
      ],
      services: ["Retail Sales", "Delivery", "Product Advice"],
      specialties: ["Premium Plywood", "BWP Grade", "MR Grade"],
    },
  },
  // Uttar Pradesh - UP East
  {
    id: 6,
    name: "Croma Ply Dealer - Varanasi",
    distance: "",
    address: "Varanasi, Uttar Pradesh",
    phone: "+91 7527070446",
    status: "Open",
    isOpen: true,
    rating: 4.5,
    reviews: 0,
    tags: ["UP East"],
    active: true,
    details: {
      image: "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?q=80&w=2400&auto=format&fit=crop",
      email: "info@cromaply.com",
      website: "www.cromaply.com",
      hours: [
        { day: "Monday - Saturday", time: "9:00 AM - 6:00 PM" },
        { day: "Sunday", time: "Closed" },
      ],
      services: ["Retail Sales", "Delivery", "Product Advice"],
      specialties: ["Premium Plywood", "BWP Grade", "MR Grade"],
    },
  },
  // Uttarakhand
  {
    id: 7,
    name: "Croma Ply Dealer - Dehradun",
    distance: "",
    address: "Dehradun, Uttarakhand",
    phone: "+91 7527070447",
    status: "Open",
    isOpen: true,
    rating: 4.5,
    reviews: 0,
    tags: ["UK"],
    active: true,
    details: {
      image: "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?q=80&w=2400&auto=format&fit=crop",
      email: "info@cromaply.com",
      website: "www.cromaply.com",
      hours: [
        { day: "Monday - Saturday", time: "9:00 AM - 6:00 PM" },
        { day: "Sunday", time: "Closed" },
      ],
      services: ["Retail Sales", "Delivery", "Product Advice"],
      specialties: ["Premium Plywood", "BWP Grade", "MR Grade"],
    },
  },
  {
    id: 8,
    name: "Croma Ply Dealer - Rudrapur",
    distance: "",
    address: "Rudrapur, Uttarakhand",
    phone: "+91 7527070447",
    status: "Open",
    isOpen: true,
    rating: 4.5,
    reviews: 0,
    tags: ["UK"],
    active: true,
    details: {
      image: "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?q=80&w=2400&auto=format&fit=crop",
      email: "info@cromaply.com",
      website: "www.cromaply.com",
      hours: [
        { day: "Monday - Saturday", time: "9:00 AM - 6:00 PM" },
        { day: "Sunday", time: "Closed" },
      ],
      services: ["Retail Sales", "Delivery", "Product Advice"],
      specialties: ["Premium Plywood", "BWP Grade", "MR Grade"],
    },
  },
  {
    id: 9,
    name: "Croma Ply Dealer - Roorkee",
    distance: "",
    address: "Roorkee, Uttarakhand",
    phone: "+91 7527070447",
    status: "Open",
    isOpen: true,
    rating: 4.5,
    reviews: 0,
    tags: ["UK"],
    active: true,
    details: {
      image: "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?q=80&w=2400&auto=format&fit=crop",
      email: "info@cromaply.com",
      website: "www.cromaply.com",
      hours: [
        { day: "Monday - Saturday", time: "9:00 AM - 6:00 PM" },
        { day: "Sunday", time: "Closed" },
      ],
      services: ["Retail Sales", "Delivery", "Product Advice"],
      specialties: ["Premium Plywood", "BWP Grade", "MR Grade"],
    },
  },
  // Bihar
  {
    id: 10,
    name: "Croma Ply Dealer - Patna",
    distance: "",
    address: "Patna, Bihar",
    phone: "+91 7527070446",
    status: "Open",
    isOpen: true,
    rating: 4.5,
    reviews: 0,
    tags: ["Bihar"],
    active: true,
    details: {
      image: "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?q=80&w=2400&auto=format&fit=crop",
      email: "info@cromaply.com",
      website: "www.cromaply.com",
      hours: [
        { day: "Monday - Saturday", time: "9:00 AM - 6:00 PM" },
        { day: "Sunday", time: "Closed" },
      ],
      services: ["Retail Sales", "Delivery", "Product Advice"],
      specialties: ["Premium Plywood", "BWP Grade", "MR Grade"],
    },
  },
  {
    id: 11,
    name: "Croma Ply Dealer - Sasaram",
    distance: "",
    address: "Sasaram, Bihar",
    phone: "+91 7527070446",
    status: "Open",
    isOpen: true,
    rating: 4.5,
    reviews: 0,
    tags: ["North Bihar"],
    active: true,
    details: {
      image: "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?q=80&w=2400&auto=format&fit=crop",
      email: "info@cromaply.com",
      website: "www.cromaply.com",
      hours: [
        { day: "Monday - Saturday", time: "9:00 AM - 6:00 PM" },
        { day: "Sunday", time: "Closed" },
      ],
      services: ["Retail Sales", "Delivery", "Product Advice"],
      specialties: ["Premium Plywood", "BWP Grade", "MR Grade"],
    },
  },
  {
    id: 12,
    name: "Croma Ply Dealer - Bhagalpur",
    distance: "",
    address: "Bhagalpur, Bihar",
    phone: "+91 7527070446",
    status: "Open",
    isOpen: true,
    rating: 4.5,
    reviews: 0,
    tags: ["North Bihar"],
    active: true,
    details: {
      image: "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?q=80&w=2400&auto=format&fit=crop",
      email: "info@cromaply.com",
      website: "www.cromaply.com",
      hours: [
        { day: "Monday - Saturday", time: "9:00 AM - 6:00 PM" },
        { day: "Sunday", time: "Closed" },
      ],
      services: ["Retail Sales", "Delivery", "Product Advice"],
      specialties: ["Premium Plywood", "BWP Grade", "MR Grade"],
    },
  },
  // Jharkhand
  {
    id: 13,
    name: "Croma Ply Dealer - Ranchi",
    distance: "",
    address: "Ranchi, Jharkhand",
    phone: "+91 7527070446",
    status: "Open",
    isOpen: true,
    rating: 4.5,
    reviews: 0,
    tags: ["Jharkhand"],
    active: true,
    details: {
      image: "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?q=80&w=2400&auto=format&fit=crop",
      email: "info@cromaply.com",
      website: "www.cromaply.com",
      hours: [
        { day: "Monday - Saturday", time: "9:00 AM - 6:00 PM" },
        { day: "Sunday", time: "Closed" },
      ],
      services: ["Retail Sales", "Delivery", "Product Advice"],
      specialties: ["Premium Plywood", "BWP Grade", "MR Grade"],
    },
  },
  // Delhi
  {
    id: 14,
    name: "Croma Ply Dealer - New Delhi",
    distance: "",
    address: "New Delhi, Delhi",
    phone: "+91 7527070447",
    status: "Open",
    isOpen: true,
    rating: 4.5,
    reviews: 0,
    tags: ["Delhi NCR"],
    active: true,
    details: {
      image: "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?q=80&w=2400&auto=format&fit=crop",
      email: "info@cromaply.com",
      website: "www.cromaply.com",
      hours: [
        { day: "Monday - Saturday", time: "9:00 AM - 6:00 PM" },
        { day: "Sunday", time: "Closed" },
      ],
      services: ["Retail Sales", "Delivery", "Product Advice"],
      specialties: ["Premium Plywood", "BWP Grade", "MR Grade"],
    },
  },
  {
    id: 15,
    name: "Croma Ply Dealer - Dwarka",
    distance: "",
    address: "Dwarka, Delhi",
    phone: "+91 7527070447",
    status: "Open",
    isOpen: true,
    rating: 4.5,
    reviews: 0,
    tags: ["Delhi NCR"],
    active: true,
    details: {
      image: "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?q=80&w=2400&auto=format&fit=crop",
      email: "info@cromaply.com",
      website: "www.cromaply.com",
      hours: [
        { day: "Monday - Saturday", time: "9:00 AM - 6:00 PM" },
        { day: "Sunday", time: "Closed" },
      ],
      services: ["Retail Sales", "Delivery", "Product Advice"],
      specialties: ["Premium Plywood", "BWP Grade", "MR Grade"],
    },
  },
  // Haryana
  {
    id: 16,
    name: "Croma Ply Dealer - Gurugram",
    distance: "",
    address: "Gurugram, Haryana",
    phone: "+91 7527070447",
    status: "Open",
    isOpen: true,
    rating: 4.5,
    reviews: 0,
    tags: ["Delhi NCR"],
    active: true,
    details: {
      image: "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?q=80&w=2400&auto=format&fit=crop",
      email: "info@cromaply.com",
      website: "www.cromaply.com",
      hours: [
        { day: "Monday - Saturday", time: "9:00 AM - 6:00 PM" },
        { day: "Sunday", time: "Closed" },
      ],
      services: ["Retail Sales", "Delivery", "Product Advice"],
      specialties: ["Premium Plywood", "BWP Grade", "MR Grade"],
    },
  },
  // Punjab
  {
    id: 17,
    name: "Croma Ply Dealer - Ludhiana",
    distance: "",
    address: "Ludhiana, Punjab",
    phone: "+91 9815481515",
    status: "Open",
    isOpen: true,
    rating: 4.5,
    reviews: 0,
    tags: ["Punjab Central"],
    active: true,
    details: {
      image: "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?q=80&w=2400&auto=format&fit=crop",
      email: "info@cromaply.com",
      website: "www.cromaply.com",
      hours: [
        { day: "Monday - Saturday", time: "9:00 AM - 6:00 PM" },
        { day: "Sunday", time: "Closed" },
      ],
      services: ["Retail Sales", "Delivery", "Product Advice"],
      specialties: ["Premium Plywood", "BWP Grade", "MR Grade"],
    },
  },
  {
    id: 18,
    name: "Croma Ply Dealer - Amritsar",
    distance: "",
    address: "Amritsar, Punjab",
    phone: "+91 9815481515",
    status: "Open",
    isOpen: true,
    rating: 4.5,
    reviews: 0,
    tags: ["Punjab North"],
    active: true,
    details: {
      image: "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?q=80&w=2400&auto=format&fit=crop",
      email: "info@cromaply.com",
      website: "www.cromaply.com",
      hours: [
        { day: "Monday - Saturday", time: "9:00 AM - 6:00 PM" },
        { day: "Sunday", time: "Closed" },
      ],
      services: ["Retail Sales", "Delivery", "Product Advice"],
      specialties: ["Premium Plywood", "BWP Grade", "MR Grade"],
    },
  },
  {
    id: 19,
    name: "Croma Ply Dealer - Jalandhar",
    distance: "",
    address: "Jalandhar, Punjab",
    phone: "+91 9815481515",
    status: "Open",
    isOpen: true,
    rating: 4.5,
    reviews: 0,
    tags: ["Punjab Doaba"],
    active: true,
    details: {
      image: "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?q=80&w=2400&auto=format&fit=crop",
      email: "info@cromaply.com",
      website: "www.cromaply.com",
      hours: [
        { day: "Monday - Saturday", time: "9:00 AM - 6:00 PM" },
        { day: "Sunday", time: "Closed" },
      ],
      services: ["Retail Sales", "Delivery", "Product Advice"],
      specialties: ["Premium Plywood", "BWP Grade", "MR Grade"],
    },
  },
  // Rajasthan
  {
    id: 20,
    name: "Croma Ply Dealer - Jaipur",
    distance: "",
    address: "Jaipur, Rajasthan",
    phone: "+91 7087599909",
    status: "Open",
    isOpen: true,
    rating: 4.5,
    reviews: 0,
    tags: ["Rajasthan East"],
    active: true,
    details: {
      image: "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?q=80&w=2400&auto=format&fit=crop",
      email: "info@cromaply.com",
      website: "www.cromaply.com",
      hours: [
        { day: "Monday - Saturday", time: "9:00 AM - 6:00 PM" },
        { day: "Sunday", time: "Closed" },
      ],
      services: ["Retail Sales", "Delivery", "Product Advice"],
      specialties: ["Premium Plywood", "BWP Grade", "MR Grade"],
    },
  },
  {
    id: 21,
    name: "Croma Ply Dealer - Jodhpur",
    distance: "",
    address: "Jodhpur, Rajasthan",
    phone: "+91 7087599909",
    status: "Open",
    isOpen: true,
    rating: 4.5,
    reviews: 0,
    tags: ["Rajasthan West"],
    active: true,
    details: {
      image: "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?q=80&w=2400&auto=format&fit=crop",
      email: "info@cromaply.com",
      website: "www.cromaply.com",
      hours: [
        { day: "Monday - Saturday", time: "9:00 AM - 6:00 PM" },
        { day: "Sunday", time: "Closed" },
      ],
      services: ["Retail Sales", "Delivery", "Product Advice"],
      specialties: ["Premium Plywood", "BWP Grade", "MR Grade"],
    },
  },
  {
    id: 22,
    name: "Croma Ply Dealer - Udaipur",
    distance: "",
    address: "Udaipur, Rajasthan",
    phone: "+91 7087599909",
    status: "Open",
    isOpen: true,
    rating: 4.5,
    reviews: 0,
    tags: ["Rajasthan West"],
    active: true,
    details: {
      image: "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?q=80&w=2400&auto=format&fit=crop",
      email: "info@cromaply.com",
      website: "www.cromaply.com",
      hours: [
        { day: "Monday - Saturday", time: "9:00 AM - 6:00 PM" },
        { day: "Sunday", time: "Closed" },
      ],
      services: ["Retail Sales", "Delivery", "Product Advice"],
      specialties: ["Premium Plywood", "BWP Grade", "MR Grade"],
    },
  },
  {
    id: 23,
    name: "Croma Ply Dealer - Kota",
    distance: "",
    address: "Kota, Rajasthan",
    phone: "+91 7087599909",
    status: "Open",
    isOpen: true,
    rating: 4.5,
    reviews: 0,
    tags: ["Rajasthan West"],
    active: true,
    details: {
      image: "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?q=80&w=2400&auto=format&fit=crop",
      email: "info@cromaply.com",
      website: "www.cromaply.com",
      hours: [
        { day: "Monday - Saturday", time: "9:00 AM - 6:00 PM" },
        { day: "Sunday", time: "Closed" },
      ],
      services: ["Retail Sales", "Delivery", "Product Advice"],
      specialties: ["Premium Plywood", "BWP Grade", "MR Grade"],
    },
  },
  // Gujarat
  {
    id: 24,
    name: "Croma Ply Dealer - Ahmedabad",
    distance: "",
    address: "Ahmedabad, Gujarat",
    phone: "+91 8968099909",
    status: "Open",
    isOpen: true,
    rating: 4.5,
    reviews: 0,
    tags: ["Gujarat Central"],
    active: true,
    details: {
      image: "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?q=80&w=2400&auto=format&fit=crop",
      email: "info@cromaply.com",
      website: "www.cromaply.com",
      hours: [
        { day: "Monday - Saturday", time: "9:00 AM - 6:00 PM" },
        { day: "Sunday", time: "Closed" },
      ],
      services: ["Retail Sales", "Delivery", "Product Advice"],
      specialties: ["Premium Plywood", "BWP Grade", "MR Grade"],
    },
  },
  {
    id: 25,
    name: "Croma Ply Dealer - Surat",
    distance: "",
    address: "Surat, Gujarat",
    phone: "+91 8968099909",
    status: "Open",
    isOpen: true,
    rating: 4.5,
    reviews: 0,
    tags: ["South Gujarat"],
    active: true,
    details: {
      image: "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?q=80&w=2400&auto=format&fit=crop",
      email: "info@cromaply.com",
      website: "www.cromaply.com",
      hours: [
        { day: "Monday - Saturday", time: "9:00 AM - 6:00 PM" },
        { day: "Sunday", time: "Closed" },
      ],
      services: ["Retail Sales", "Delivery", "Product Advice"],
      specialties: ["Premium Plywood", "BWP Grade", "MR Grade"],
    },
  },
  // Maharashtra
  {
    id: 26,
    name: "Croma Ply Dealer - Mumbai",
    distance: "",
    address: "Mumbai, Maharashtra",
    phone: "+91 8968099909",
    status: "Open",
    isOpen: true,
    rating: 4.5,
    reviews: 0,
    tags: ["Maharashtra West"],
    active: true,
    details: {
      image: "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?q=80&w=2400&auto=format&fit=crop",
      email: "info@cromaply.com",
      website: "www.cromaply.com",
      hours: [
        { day: "Monday - Saturday", time: "9:00 AM - 6:00 PM" },
        { day: "Sunday", time: "Closed" },
      ],
      services: ["Retail Sales", "Delivery", "Product Advice"],
      specialties: ["Premium Plywood", "BWP Grade", "MR Grade"],
    },
  },
  {
    id: 27,
    name: "Croma Ply Dealer - Pune",
    distance: "",
    address: "Pune, Maharashtra",
    phone: "+91 8968099909",
    status: "Open",
    isOpen: true,
    rating: 4.5,
    reviews: 0,
    tags: ["Maharashtra West"],
    active: true,
    details: {
      image: "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?q=80&w=2400&auto=format&fit=crop",
      email: "info@cromaply.com",
      website: "www.cromaply.com",
      hours: [
        { day: "Monday - Saturday", time: "9:00 AM - 6:00 PM" },
        { day: "Sunday", time: "Closed" },
      ],
      services: ["Retail Sales", "Delivery", "Product Advice"],
      specialties: ["Premium Plywood", "BWP Grade", "MR Grade"],
    },
  },
  {
    id: 28,
    name: "Croma Ply Dealer - Nagpur",
    distance: "",
    address: "Nagpur, Maharashtra",
    phone: "+91 8968099909",
    status: "Open",
    isOpen: true,
    rating: 4.5,
    reviews: 0,
    tags: ["Vidarbha"],
    active: true,
    details: {
      image: "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?q=80&w=2400&auto=format&fit=crop",
      email: "info@cromaply.com",
      website: "www.cromaply.com",
      hours: [
        { day: "Monday - Saturday", time: "9:00 AM - 6:00 PM" },
        { day: "Sunday", time: "Closed" },
      ],
      services: ["Retail Sales", "Delivery", "Product Advice"],
      specialties: ["Premium Plywood", "BWP Grade", "MR Grade"],
    },
  },
  // Jammu & Kashmir
  {
    id: 29,
    name: "Croma Ply Dealer - Jammu",
    distance: "",
    address: "Jammu, Jammu & Kashmir",
    phone: "+91 9875938091",
    status: "Open",
    isOpen: true,
    rating: 4.5,
    reviews: 0,
    tags: ["Jammu Region"],
    active: true,
    details: {
      image: "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?q=80&w=2400&auto=format&fit=crop",
      email: "info@cromaply.com",
      website: "www.cromaply.com",
      hours: [
        { day: "Monday - Saturday", time: "9:00 AM - 6:00 PM" },
        { day: "Sunday", time: "Closed" },
      ],
      services: ["Retail Sales", "Delivery", "Product Advice"],
      specialties: ["Premium Plywood", "BWP Grade", "MR Grade"],
    },
  },
  {
    id: 30,
    name: "Croma Ply Dealer - Srinagar",
    distance: "",
    address: "Srinagar, Jammu & Kashmir",
    phone: "+91 9875938091",
    status: "Open",
    isOpen: true,
    rating: 4.5,
    reviews: 0,
    tags: ["Kashmir Valley"],
    active: true,
    details: {
      image: "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?q=80&w=2400&auto=format&fit=crop",
      email: "info@cromaply.com",
      website: "www.cromaply.com",
      hours: [
        { day: "Monday - Saturday", time: "9:00 AM - 6:00 PM" },
        { day: "Sunday", time: "Closed" },
      ],
      services: ["Retail Sales", "Delivery", "Product Advice"],
      specialties: ["Premium Plywood", "BWP Grade", "MR Grade"],
    },
  },
  // Tricity
  {
    id: 31,
    name: "Croma Ply Dealer - Chandigarh",
    distance: "",
    address: "Chandigarh, Tricity",
    phone: "+91 9815481515",
    status: "Open",
    isOpen: true,
    rating: 4.5,
    reviews: 0,
    tags: ["Tricity"],
    active: true,
    details: {
      image: "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?q=80&w=2400&auto=format&fit=crop",
      email: "info@cromaply.com",
      website: "www.cromaply.com",
      hours: [
        { day: "Monday - Saturday", time: "9:00 AM - 6:00 PM" },
        { day: "Sunday", time: "Closed" },
      ],
      services: ["Retail Sales", "Delivery", "Product Advice"],
      specialties: ["Premium Plywood", "BWP Grade", "MR Grade"],
    },
  },
  {
    id: 32,
    name: "Croma Ply Dealer - Mohali",
    distance: "",
    address: "Mohali, Tricity",
    phone: "+91 9815481515",
    status: "Open",
    isOpen: true,
    rating: 4.5,
    reviews: 0,
    tags: ["Tricity"],
    active: true,
    details: {
      image: "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?q=80&w=2400&auto=format&fit=crop",
      email: "info@cromaply.com",
      website: "www.cromaply.com",
      hours: [
        { day: "Monday - Saturday", time: "9:00 AM - 6:00 PM" },
        { day: "Sunday", time: "Closed" },
      ],
      services: ["Retail Sales", "Delivery", "Product Advice"],
      specialties: ["Premium Plywood", "BWP Grade", "MR Grade"],
    },
  },
  {
    id: 33,
    name: "Croma Ply Dealer - Panchkula",
    distance: "",
    address: "Panchkula, Tricity",
    phone: "+91 9815481515",
    status: "Open",
    isOpen: true,
    rating: 4.5,
    reviews: 0,
    tags: ["Tricity"],
    active: true,
    details: {
      image: "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?q=80&w=2400&auto=format&fit=crop",
      email: "info@cromaply.com",
      website: "www.cromaply.com",
      hours: [
        { day: "Monday - Saturday", time: "9:00 AM - 6:00 PM" },
        { day: "Sunday", time: "Closed" },
      ],
      services: ["Retail Sales", "Delivery", "Product Advice"],
      specialties: ["Premium Plywood", "BWP Grade", "MR Grade"],
    },
  },
  // Himachal
  {
    id: 34,
    name: "Croma Ply Dealer - Hamirpur",
    distance: "",
    address: "Hamirpur, Himachal Pradesh",
    phone: "+91 9815481515",
    status: "Open",
    isOpen: true,
    rating: 4.5,
    reviews: 0,
    tags: ["Himachal"],
    active: true,
    details: {
      image: "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?q=80&w=2400&auto=format&fit=crop",
      email: "info@cromaply.com",
      website: "www.cromaply.com",
      hours: [
        { day: "Monday - Saturday", time: "9:00 AM - 6:00 PM" },
        { day: "Sunday", time: "Closed" },
      ],
      services: ["Retail Sales", "Delivery", "Product Advice"],
      specialties: ["Premium Plywood", "BWP Grade", "MR Grade"],
    },
  },
];

export const BLOG_POSTS: BlogPost[] = [
  {
    id: 1,
    slug: "choosing-the-right-plywood-for-your-project",
    title: "Choosing the Right Plywood for Your Project",
    image: "/assets/images/blogs/blog-1.webp",
    tag: "GUIDE",
    author: "Darlene Robertson",
    role: "Marketing Coordinator",
    readTime: "10 min read",
    avatar: "https://randomuser.me/api/portraits/women/1.jpg",
    date: "15 Jan 2025",
    content: {
      paragraphs: [
        "Selecting the right plywood for your construction or furniture project is crucial for achieving optimal results. With various grades, types, and specifications available, understanding the key factors can help you make an informed decision.",
        "From structural applications to interior finishing, each project has unique requirements that determine the best plywood choice."
      ],
      sections: [
        {
          heading: "Understanding Plywood Grades For Your Needs",
          paragraphs: [
            "Plywood grades indicate the quality and appearance of the wood veneers used. Higher grades offer better aesthetics and fewer defects, making them ideal for visible applications."
          ],
          listItems: [
            "Marine-grade plywood for moisture-prone environments",
            "MR grade for interior applications with moderate humidity",
            "BWP grade for exterior use and high-moisture areas",
            "Commercial grade for structural and hidden applications"
          ]
        },
        {
          heading: "Key Factors To Consider When Choosing",
          paragraphs: [
            "Beyond grade, consider thickness, core type, and certification standards. These factors directly impact performance, durability, and compliance with building codes."
          ],
          listItems: [
            "Project location and exposure to moisture or weather",
            "Load-bearing requirements and structural needs",
            "Finishing requirements and aesthetic expectations",
            "Budget constraints and long-term value"
          ]
        }
      ],
      closing: {
        thanks: "Thanks for reading,",
        author: "Darlene"
      }
    }
  },
  {
    id: 2,
    slug: "why-calibrated-plywood-ensures-better-finishing",
    title: "Why Calibrated Plywood Ensures Better Finishing",
    image: "/assets/images/blogs/blog-2.webp",
    tag: "MANUFACTURING",
    author: "Darlene Robertson",
    role: "Marketing Coordinator",
    readTime: "10 min read",
    avatar: "https://randomuser.me/api/portraits/women/2.jpg",
    date: "12 Jan 2025",
    content: {
      paragraphs: [
        "Calibrated plywood undergoes precision thickness control during manufacturing, ensuring uniform dimensions across every sheet. This consistency is essential for achieving smooth, professional finishes in furniture and interior applications.",
        "The calibration process eliminates thickness variations that can cause gaps, uneven surfaces, and finishing challenges."
      ],
      sections: [
        {
          heading: "Precision Manufacturing For Perfect Surfaces",
          paragraphs: [
            "Calibrated plywood is processed through advanced machinery that ensures exact thickness tolerances. This precision translates directly to better finishing results."
          ],
          listItems: [
            "Eliminates surface irregularities and thickness variations",
            "Ensures seamless edge joining and panel alignment",
            "Reduces sanding time and material waste",
            "Provides consistent base for laminates and veneers"
          ]
        },
        {
          heading: "Benefits For Professional Finishing",
          paragraphs: [
            "Whether applying paint, laminate, or veneer, calibrated plywood provides a uniform surface that accepts finishes evenly and maintains professional appearance."
          ],
          listItems: [
            "Smooth, even surfaces ready for immediate finishing",
            "Reduced material preparation time and costs",
            "Professional-grade results with standard finishing techniques",
            "Long-lasting finish quality and appearance"
          ]
        }
      ],
      closing: {
        thanks: "Thanks for reading,",
        author: "Darlene"
      }
    }
  },
  {
    id: 3,
    slug: "the-difference-between-bwp-and-mr-plywood",
    title: "The Difference Between BWP and MR Plywood",
    image: "/assets/images/blogs/blog-3.webp",
    tag: "MATERIALS",
    author: "Darlene Robertson",
    role: "Marketing Coordinator",
    readTime: "10 min read",
    avatar: "https://randomuser.me/api/portraits/women/3.jpg",
    date: "10 Jan 2025",
    content: {
      paragraphs: [
        "Understanding the difference between BWP (Boiling Water Proof) and MR (Moisture Resistant) plywood is essential for selecting the right material for your specific application. Both offer moisture protection, but at different levels.",
        "The key distinction lies in their adhesive formulations and testing standards, which determine their suitability for various environments."
      ],
      sections: [
        {
          heading: "BWP Plywood: Maximum Moisture Protection",
          paragraphs: [
            "BWP plywood uses phenolic resin adhesives that provide superior water resistance. It undergoes rigorous 72-hour boiling water tests to ensure durability in extreme conditions."
          ],
          listItems: [
            "Ideal for exterior applications and high-moisture areas",
            "Suitable for bathrooms, kitchens, and outdoor structures",
            "Withstands prolonged exposure to water and humidity",
            "Higher cost but superior long-term durability"
          ]
        },
        {
          heading: "MR Plywood: Standard Moisture Resistance",
          paragraphs: [
            "MR plywood uses melamine-urea-formaldehyde adhesives that provide moderate moisture resistance. It's designed for interior applications with normal humidity levels."
          ],
          listItems: [
            "Perfect for interior furniture and cabinetry",
            "Suitable for dry and moderately humid indoor spaces",
            "Cost-effective solution for standard applications",
            "Not recommended for exterior or high-moisture areas"
          ]
        }
      ],
      closing: {
        thanks: "Thanks for reading,",
        author: "Darlene"
      }
    }
  },
  {
    id: 4,
    slug: "fire-retardant-plywood-where-and-why-it-matters",
    title: "Fire-Retardant Plywood: Where and Why It Matters",
    image: "/assets/images/blogs/blog-4.webp",
    tag: "SAFETY",
    author: "Darlene Robertson",
    role: "Marketing Coordinator",
    readTime: "10 min read",
    avatar: "https://randomuser.me/api/portraits/women/4.jpg",
    date: "8 Jan 2025",
    content: {
      paragraphs: [
        "Fire-retardant plywood is treated with special chemicals that slow down the spread of flames and reduce smoke generation. This makes it a critical safety material in commercial and residential construction where fire safety is paramount.",
        "Understanding where and why fire-retardant plywood matters can help ensure compliance with building codes and enhance overall safety."
      ],
      sections: [
        {
          heading: "Critical Applications For Fire Safety",
          paragraphs: [
            "Fire-retardant plywood is essential in areas where fire safety regulations are strict, such as commercial buildings, public spaces, and multi-story residential structures."
          ],
          listItems: [
            "Commercial buildings and office spaces",
            "Hotels, hospitals, and public facilities",
            "Multi-story residential buildings",
            "Escape routes and fire-rated partitions"
          ]
        },
        {
          heading: "Why Fire-Retardant Treatment Matters",
          paragraphs: [
            "Fire-retardant treatment significantly improves the fire performance of plywood, providing crucial time for evacuation and firefighting efforts while meeting regulatory requirements."
          ],
          listItems: [
            "Delays flame spread and reduces fire intensity",
            "Minimizes smoke generation during fire incidents",
            "Complies with building codes and safety regulations",
            "Provides additional protection for occupants and property"
          ]
        }
      ],
      closing: {
        thanks: "Thanks for reading,",
        author: "Darlene"
      }
    }
  },
  {
    id: 5,
    slug: "how-high-density-core-improves-furniture-durability",
    title: "How High-Density Core Improves Furniture Durability",
    image: "/assets/images/blogs/blog-5.webp",
    tag: "FURNITURE",
    author: "Darlene Robertson",
    role: "Marketing Coordinator",
    readTime: "10 min read",
    avatar: "https://randomuser.me/api/portraits/women/5.jpg",
    date: "5 Jan 2025",
    content: {
      paragraphs: [
        "High-density core plywood has revolutionized furniture manufacturing by providing exceptional strength, stability, and durability. The increased core density results from tightly compressed hardwood layers that create a superior structural foundation.",
        "This enhanced construction translates directly to furniture that withstands daily use, maintains its shape over time, and delivers long-lasting performance."
      ],
      sections: [
        {
          heading: "Superior Strength For Lasting Furniture",
          paragraphs: [
            "High-density core plywood offers significantly improved load-bearing capacity and resistance to bending, making it ideal for furniture that needs to support weight and withstand stress."
          ],
          listItems: [
            "Enhanced load-bearing capacity for heavy furniture",
            "Superior screw-holding power for secure joints",
            "Reduced risk of sagging or deformation over time",
            "Better resistance to impact and wear"
          ]
        },
        {
          heading: "Long-Term Durability Benefits",
          paragraphs: [
            "The tightly compressed core structure ensures dimensional stability, preventing warping, twisting, or shrinking that can compromise furniture integrity and appearance."
          ],
          listItems: [
            "Maintains shape and dimensions in varying conditions",
            "Resists moisture-related expansion and contraction",
            "Provides consistent performance throughout furniture lifespan",
            "Reduces maintenance and replacement costs"
          ]
        }
      ],
      closing: {
        thanks: "Thanks for reading,",
        author: "Darlene"
      }
    }
  },
  {
    id: 6,
    slug: "understanding-isi-standards-for-quality-plywood",
    title: "Understanding ISI Standards for Quality Plywood",
    image: "/assets/images/blogs/blog-6.webp",
    tag: "QUALITY",
    author: "Darlene Robertson",
    role: "Marketing Coordinator",
    readTime: "10 min read",
    avatar: "https://randomuser.me/api/portraits/women/6.jpg",
    date: "3 Jan 2025",
    content: {
      paragraphs: [
        "ISI (Indian Standards Institute) certification ensures that plywood meets specific quality, safety, and performance standards. Understanding these standards helps you identify genuine, reliable products that comply with national quality requirements.",
        "ISI-marked plywood undergoes rigorous testing and quality control processes, providing assurance of consistent quality and performance."
      ],
      sections: [
        {
          heading: "What ISI Certification Guarantees",
          paragraphs: [
            "ISI certification verifies that plywood meets established standards for thickness, strength, moisture resistance, and overall quality. This certification is your assurance of product reliability."
          ],
          listItems: [
            "Verified thickness and dimensional accuracy",
            "Tested strength and load-bearing capacity",
            "Confirmed adhesive quality and bonding strength",
            "Validated moisture resistance and durability"
          ]
        },
        {
          heading: "Why ISI Standards Matter",
          paragraphs: [
            "Choosing ISI-certified plywood ensures you're getting products that have been independently tested and verified to meet quality standards, reducing the risk of substandard materials affecting your project."
          ],
          listItems: [
            "Assurance of consistent quality and performance",
            "Compliance with national building and safety standards",
            "Reduced risk of premature failure or defects",
            "Better value through verified product reliability"
          ]
        }
      ],
      closing: {
        thanks: "Thanks for reading,",
        author: "Darlene"
      }
    }
  }
];

// Blog posts for BlogSection (with badge and description)
export const BLOG_SECTION_POSTS: BlogPost[] = [
  {
    id: 1,
    slug: "sustainable-plywood-solutions-for-modern-construction",
    title: "Sustainable Plywood Solutions for Modern Construction",
    image: "https://images.unsplash.com/photo-1533090161767-e6ffed986c88?q=80&w=2400&auto=format&fit=crop",
    tag: "SUSTAINABLE",
    badge: "SUSTAINABLE",
    author: "Rohan Sharma",
    role: "Product Specialist",
    readTime: "5 min read",
    avatar: "https://randomuser.me/api/portraits/men/32.jpg",
    description: "Discover how modern plywood manufacturing incorporates eco-friendly practices while maintaining superior quality and durability for your construction projects."
  },
  {
    id: 2,
    slug: "how-high-density-plywood-improves-structural-performance",
    title: "How High-Density Plywood Improves Structural Performance",
    image: "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?q=80&w=2400&auto=format&fit=crop",
    tag: "CONSTRUCTION",
    badge: "CONSTRUCTION",
    author: "Rohan Sharma",
    role: "Product Specialist",
    readTime: "10 min read",
    avatar: "https://randomuser.me/api/portraits/men/32.jpg",
    description: "High-density plywood has revolutionized modern construction by offering exceptional load-bearing capabilities, superior dimensional stability, and enhanced durability.",
    date: "20 Jan 2025",
    content: {
      paragraphs: [
        "High-density plywood has emerged as a standout material in modern construction and interior applications. Engineered under extreme pressure with superior-grade veneers, it delivers performance benefits that go far beyond traditional plywood.",
        "From enhanced load-bearing capability to exceptional dimensional stability, high-density plywood is now the preferred choice for architects, contractors, and furniture manufacturers who demand durability and precision."
      ],
      sections: [
        {
          heading: "Stronger Composition For Superior Strength",
          paragraphs: [
            "High-density plywood is manufactured using closely bonded hardwood layers, which increases its core density and structural integrity. This upgraded construction ensures:"
          ],
          listItems: [
            "Better load distribution across each panel",
            "Higher bending strength for heavy-duty use",
            "Minimal warping or deformation, even under harsh conditions"
          ]
        },
        {
          heading: "Why High-Density Plywood Stands Out",
          paragraphs: [
            "From kitchens to commercial interiors, high-density plywood continues to prove its value with:"
          ],
          listItems: [
            "Higher mechanical strength that supports larger spans and heavier loads",
            "Superior screw-holding capability, especially for high-traffic installations",
            "Improved moisture resistance due to tightly compressed layers",
            "Long-lasting shape retention, even in fluctuating climates"
          ]
        }
      ],
      closing: {
        thanks: "Thanks for reading,",
        author: "Rohit"
      }
    }
  },
  {
    id: 3,
    slug: "fire-retardant-plywood-guide-for-commercial-buildings",
    title: "Fire-Retardant Plywood Guide for Commercial Buildings",
    image: "https://images.unsplash.com/photo-1620121692029-d088224ddc74?q=80&w=2532&auto=format&fit=crop",
    tag: "SAFETY",
    badge: "SAFETY",
    author: "Rohan Sharma",
    role: "Product Specialist",
    readTime: "7 min read",
    avatar: "https://randomuser.me/api/portraits/men/32.jpg",
    description: "Learn about the critical importance of fire-retardant plywood in commercial and residential construction, and how it provides essential safety protection."
  }
];

export interface AdvantageTab {
  title: string;
  desc: string;
  image: string;
}

export const ADVANTAGE_TABS: AdvantageTab[] = [
  {
    title: "Developing the Core",
    desc: "Crafted with carefully selected hardwood species, precision-calibrated layers, and advanced resin formulations.",
    image: "/assets/images/advantages/core.webp",
  },
  {
    title: "Ensuring Stability",
    desc: "Cross-grain bonding technology ensures maximum stability and resistance to warping under varying conditions.",
    image: "/assets/images/advantages/ensuring-stability.webp",
  },
  {
    title: "Designing for Strength",
    desc: "High-density core composition provides superior load-bearing capacity and structural integrity.",
    image: "/assets/images/advantages/strength.webp",
  },
  {
    title: "Testing & Validation",
    desc: "Rigorous 72-hour boiling water proof tests and strict quality control measures for every sheet.",
    image: "/assets/images/advantages/testing-and-validation.webp",
  },
  {
    title: "Improving Continuously",
    desc: "Constant innovation in manufacturing processes to deliver the best plywood solutions.",
    image: "/assets/images/advantages/improving-continuously.webp",
  },
];

